/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACES
import { ProtocolInterface } from "../../interfaces/Protocols.interface";
// CONSTANTS
import { BLANK_PROTOCOL } from "../../constants/protocol";

export interface ProtocolState {
	protocol: ProtocolInterface;
	openDrawer: boolean;
	openForm: boolean;
	refreshTable: boolean;
	formAction: string;
	openModalDelete: boolean;
}

const initialState: ProtocolState = {
	protocol: { ...BLANK_PROTOCOL },
	openDrawer: false,
	openForm: false,
	refreshTable: false,
	formAction: "CREATE",
	openModalDelete: false,
};

export const protocolSlice = createSlice({
	name: "protocol",
	initialState,
	reducers: {
		updateProtocol: (state, action: PayloadAction<ProtocolInterface>) => {
			state.protocol = action.payload;
		},
		updateOpenDrawer: (state, action: PayloadAction<boolean>) => {
			state.openDrawer = action.payload;
		},
		updateOpenForm: (state, action: PayloadAction<boolean>) => {
			state.openForm = action.payload;
		},
		updateRefreshTable: (state, action: PayloadAction<boolean>) => {
			state.refreshTable = action.payload;
		},
		updateFormAction: (state, action: PayloadAction<string>) => {
			state.formAction = action.payload;
		},
		updateOpenModalDelete: (state, action: PayloadAction<boolean>) => {
			state.openModalDelete = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	updateProtocol,
	updateOpenDrawer,
	updateOpenForm,
	updateRefreshTable,
	updateFormAction,
	updateOpenModalDelete,
} = protocolSlice.actions;

export default protocolSlice.reducer;
